import type {DashboardManagement} from "../types";
import {OfficersCard} from "./officers-card";
import {PropertiesCard} from "./properties-card";
import {ShiftsCard} from "./shifts-card";

type ManagementSectionProps = {
  management: DashboardManagement;
};

export function ManagementSection({management}: ManagementSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
      <ShiftsCard shifts={management.shifts} />
      <OfficersCard officers={management.officers} />
      <PropertiesCard properties={management.properties} />
    </div>
  );
}
